import { IEntityDto } from "./base";
import { IXenaAppPluginTranslation } from "./xena-app-plugin-translation";

export interface IXenaAppPlugin extends IEntityDto {
  title?: string;
  iconCssClass?: null,
  index?: null,
  pluginPlacement?: string;
  pluginType?: string;
  externalUri?: string;
  xenaAppId?: number;
  parentPluginId?: null,
  sandboxAllowForms?: boolean;
  sandboxAllowPopups?: boolean;
  sandboxAllowPopupsEscape?: boolean;
  sandboxAllowModals?: boolean;
  sandboxAllowDownloads?: boolean;
  pluginPlacementTranslated?: string;
  pluginTypeTranslated?: string;
  translations: { [key: string]: IXenaAppPluginTranslation }
}
